import React, { useEffect, useState } from "react";
import { errorMsg, successMsg } from "../../Toastify";
import { useSelector } from "react-redux";
import {
  CreateDepartmentMaster,
  GetDepartmentList,
  UpdateDepartmentMaster,
} from "../../../Repository/Api";
import CustomModal from "../../CustomModal";
const itemsPerPage = 10;

const Departmentmaster = () => {
          const { first_name, desingation, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const [department, setDepartment] = useState([]);
  const [masterModel, setMasterModel] = useState(false);
  const [createDepartment, setCreateDepartment] = useState({});
  const [validation, setValidation] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  const [dummyleaveList, setdummyLeaveList] = useState([]);

  const [searchText, setSearchText] = useState('')
  

  const SearchfilteredData = dummyleaveList?.filter(item =>
    Object.values(item).some(value =>
      value?.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );
  useEffect(() => {
    if (searchText) {
      setDepartment(SearchfilteredData)
      setCurrentPage(1)
    } else {
      setDepartment(dummyleaveList)
    }
  }, [searchText, dummyleaveList])
  
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = department.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    getDepartmentList();
  },[]);

  const getDepartmentList = async () => {
    const response = await GetDepartmentList(token);
    if (response && response.statusCode === 200) {
      // setDepartment(response?.data?.department);
      setdummyLeaveList(response?.data?.department)
    } else {
      errorMsg(response.message);
    }
  };

  const setData = (e, key) => {
    let TempData = createDepartment;
    TempData[key] = e;
    setCreateDepartment(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const CheckValidation = () => {
    let Status = true,
      validdateData = {};
    if (!createDepartment.name) {
      validdateData.name = "Department Name is Required";
      Status = false;
    }
    setValidation({ ...validation, ...validdateData });
    return Status;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (CheckValidation()) {
      const Payload = {
        name: createDepartment.name,
      };
      const response = await CreateDepartmentMaster(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateDepartment({});
        setMasterModel(false);
        e.target.reset();
        getDepartmentList();
      } else {
        errorMsg(response.message);
      }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (CheckValidation()) {
      const Payload = {
        id: createDepartment.id,
        name: createDepartment.name,
      };
      const response = await UpdateDepartmentMaster(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateDepartment({});
        setMasterModel(false);
        e.target.reset();
        getDepartmentList();
      } else {
        errorMsg(response.message);
      }
    }
  };

  return (
    <>
      <div>

        <div className="row justify-content-center mt-3">
          <div className="col-lg-6">
            <div class="input-group flex-nowrap">
              <span class="input-group-text" id="addon-wrapping"><span class="material-symbols-outlined search-input-icon">search</span></span>
              <input type="text" class="form-control search-table-data"
                placeholder="Search"
                aria-describedby="addon-wrapping"
                name="search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </div>
          <button
            type="button "
            className="btn add-btn col-lg-2"
            onClick={() => setMasterModel(true)}
          >
            <span className="material-symbols-outlined align-middle iconsize">
              add_circle
            </span>
            <span className="align-middle"> Add</span>
          </button>
        </div>

        <div className="graphbox">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">S.No</th>
                <th scope="col">Department Name</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems &&
                currentItems.map((depart, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td
                      className="namelink textformat"
                      onClick={() => {
                        setMasterModel(true);
                        setCreateDepartment(depart);
                      }}
                    >
                      {depart?.name}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td></td>
                  <td>
                    <div> No Data Found </div>
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="4">
                  <nav aria-label="...">
                    <ul className="pagination">
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {Array.from({
                        length: Math.ceil(department.length / itemsPerPage),
                      }).map((_, index) => {
                        if (
                          index + 1 >= currentPage - 4 && // Display 4 pages before current page
                          index + 1 <= currentPage + 5 // Display 5 pages after current page
                        ) {
                          return (
                            <li
                              key={index}
                              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                            >
                              <button
                                className="page-link"
                                onClick={() => paginate(index + 1)}
                              >
                                {index + 1}
                              </button>
                            </li>
                          );
                        }
                        return null; // Hide pages outside the range
                      })}
                      <li
                        className={`page-item ${currentPage === Math.ceil(department.length / itemsPerPage) ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* masterModel */}
      <CustomModal
        open={masterModel}
        onClickOutside={() => {
          setMasterModel(false);
          setCreateDepartment({});
        }}
      >
        <form
          onSubmit={(e) => {
            if (createDepartment.id) {
              handleUpdate(e);
            } else {
              handleSubmit(e);
            }
          }}
        >
          <div className="modal-content Modal-View m-auto">
            <div className="modalHeader text-center py-2">
              <h5 className="font-bold mt-2">
                {createDepartment.id ? "Update" : "Add New"}
                &nbsp;Department Master
              </h5>
            </div>
            <div className="modal-body p-0 ">
              <div className="container">
                <div className="row d-flex align-items-center justify-content-center  mt-0">
                  <div className="container ">
                    <div className="row justify-content-center">
                      <div className="col-lg-8">
                        <div className=" my-5 px-3">
                          <div className="row justify-content-center mt-2">
                            <div className="col-lg-10">
                              <div className="mb-3">
                                <label className="labeltext">
                                  Name of the Department:
                                </label>
                                <input
                                  type="text"
                                  className="fieldinput"
                                  placeholder="Enter Name of the Department"
                                  defaultValue={createDepartment?.name}
                                  onChange={(e) => {
                                    setData(e.target.value, "name");
                                  }}
                                />
                                {validation.name && (
                                  <p className="validationerror">
                                    {validation.name}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0">
              <div>
                <button
                  type="button"
                  className="btn mx-2 submit-btn"
                  onClick={() => {
                    setMasterModel(false);
                    setValidation({});
                    setCreateDepartment({});
                  }}
                >
                  Back
                </button>
              </div>
              <div>
                <button className="btn mx-2 submit-btn">
                  {createDepartment.id ? "Update" : "Create"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </CustomModal>
    </>
  );
};

export default Departmentmaster;
